import { getTimelineUserChanges } from '@api';
import { createGetAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreTimelineUserChangesGetAsyncSlice = createGetAsyncSlice({
	name: 'CoreTimelineUserChanges',
	receive: true,
	request: true,
	requestHandler: getTimelineUserChanges,
	retainDataOnRequest: true,
	yieldType: SagaYieldType.Latest
});
